import React, { useState,useRef } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot,faUser, faPhone, faVenusMars } from '@fortawesome/free-solid-svg-icons';
import '../Css/ServiceForm.css';

const cookies = new Cookies;


function ServiceForm() {
    // Control the state of button
    const [isLoading, setIsLoading] = useState(false);
  
    const orderType = cookies.get('orderType');  
    const [name,setName]=useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [gender, setGender] = useState("");
    const [showDistrict, setShowDistrict] = useState(false);
    const [district, setDistrict] = useState(null);
    const [townValue, setTownValue] = useState(null);
    const [town,setTown] = useState(null)
   
    const [urgent, setUrgent] = useState(false);
    const [comment, setComment] = useState("");
    const [rfFamily, setRfFamily] = useState(false);
  
    
    // Store image content
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const fileInputRef = useRef(null);

    // Permission to display image
    const [showImagePicker, setShowImagePicker] = useState(false);

    function setTargetImage(data) {
      setImage(data);
      console.log("Target Image uri:", data);
    }

    // To Camera Component
    const onPressImagePicker = () => {
      setShowImagePicker(true);
    }


    //report price
    const [reportPriceState, setReportPriceState] = useState(false);
    const [reportPrice, setReportPrice] = useState(0);
    
    let targetService;

   
    if (orderType === 1) {
      targetService = "電力維修";
    }
    if (orderType === 2) {
      targetService = "水喉維修";
    }

    if (orderType === 3) {
      targetService = "門銷維修";
    }

    if (orderType === 4) {
      targetService = "鋁窗維修";
    }

    if (orderType === 5) {
      targetService = "木門/閘門維修";
    }

    if (orderType === 6) {
      targetService = "家具及家俬安裝";
    }

    if (orderType === 7) {
      targetService = "油漆";
    }

    if (orderType === 8) {
      targetService = "地板安裝/維修";
    }
  
    if (orderType === 9) {
      targetService = "石屎剥落";
    }

    if (orderType === 10) {
      targetService = "裝修工程";
    }

    if (orderType === 11) {
      targetService = "驗窗";
    }

    if (orderType === 12) {
      targetService = "冷氣安裝及維修";
    }

    if (orderType === 13) {
      targetService = "商業維修";
    }




     /********* District Selection *********/
    const districtOptions = [
        { id: 1, label: "香港" },
        { id: 2, label: "九龍" },
        { id: 3, label: "新界" },
    ];

    const handleDistrictSelect = (optionId) => {
        setDistrict(optionId);
        console.log("You have choice this district:", optionId);
    }

    /********* Town Selection *************/
    const handleTownSelect = (optionId, optionLabel) => {
        setTown(optionId);
        setShowDistrict(true);
        setTownValue(optionLabel);
        console.log("You have choice this town:", optionId);
    }

    let townOptions = [];
    if (district == "1") {
        townOptions = [
        { id: 11, label: "中西區" },
        { id: 12, label: "東區" },
        { id: 13, label: "南區" },
        { id: 14, label: "灣仔區" },
        ];
    }

    if (district == "2") {
        townOptions = [
        { id: 21, label: "油尖旺區" },
        { id: 22, label: "深水埗區" },
        { id: 23, label: "九龍城區" },
        { id: 24, label: "觀塘區" },
        { id: 25, label: "黃大仙區" },
        ];
    }

    if (district == "3") {
        townOptions = [
        { id: 31, label: "元朗" },
        { id: 32, label: "天水圍" },
        { id: 33, label: "屯門" },
        { id: 34, label: "葵涌" },
        { id: 35, label: "青衣" },
        { id: 36, label: "荃灣區" },
        { id: 37, label: "離島區" },
        { id: 38, label: "北區" },
        { id: 39, label: "大埔區" },
        { id: 40, label: "沙田" },
        { id: 41, label: "馬峖山" },
        { id: 42, label: "大圍" },
        { id: 43, label: "西貢" },
        { id: 44, label: "將軍澳" },
        ];
    }

    // Reset district
    const resetDistrict = () => {
        setShowDistrict(false);
        setDistrict(null);
        setTown(null);
        console.log("Reset District");
  }
  
    //Image
    // Handle file selection
    const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check if file is an image
      if (!file.type.startsWith('image/')) {
        alert('請選擇圖片文件');
        return;
      }
      
      // Check file size (e.g., 5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        alert('圖片大小不能超過 5MB');
        return;
      }

      setImage(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
    };

    // Trigger file input click
    const handleUploadClick = () => {
      fileInputRef.current?.click();
    };

    // Remove selected image
    const handleRemoveImage = () => {
      setImage(null);
      setImagePreview(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    };
  
  //Send push notification
  const sendNotification = async () => {
    console.log("Sending Push Notification..");
    try {
      const url = "https://homerepairexperthk.com/sendpushClient.php"
      const response = await axios.post(url);
      console.log("Response from Push Notification-ServiceApplication:", response.data);
      console.warn(response.status);
      if (response.status === 200) {
        console.log("Success-ServiceApplication !");
      }
    } catch (error) {
      console.log(error);
    }
  }


  const pressHandler = (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    console.log("IsLoading State:", isLoading);
   
    console.log("User Name:", name);
    console.log("phoneNum", phoneNum);
    console.log("gender", gender);
    console.log("district", district);
    console.log("town", town);
    console.log("Urgent", urgent);
    console.log("Report Price", reportPrice);
    console.log("RfFamily", rfFamily);
    console.log("Comment", comment);
    console.log("Image", image);
     
    let pushToken = "none";
    let showInfor = "true";
    let formValid = false;
      
    // Check form valid
    if (name != '' && district != null && gender != '' && town != null) {
      formValid = true;
    } else {
      if (name == '') {
        console.log("Please Enter your name");
        alert("請填上名稱");
        setIsLoading(false);
      }
      if (town == null && name != '' && district != '' && gender != '') {
        alert("請選擇市區");
        setIsLoading(false);
      }
      if (district == null && name != '' && town != null && gender != '') {
        alert("請選擇市區");
        setIsLoading(false);
      }
      if (gender == '' && name != '') {
        alert("請選擇性別");
        setIsLoading(false);
      }
    }

    // Send to server
    if (formValid === true) {
      console.log("Form Valid");
      const data = new FormData();
      data.append('orderType', orderType);
      data.append('district', district);
      data.append('town', town);
      data.append('comment', comment);
      data.append('urgent', urgent);
      data.append('clientGender', gender);
      data.append('clientName', name);
      data.append('phoneNum', phoneNum);
      data.append('rfFamily', rfFamily);
      data.append('reportPrice', reportPrice);
      data.append('pushToken', pushToken);
      data.append('showInfor', showInfor);

      //Image
      if (image != null) {
        data.append('file', image);
      }
      
      let resultData = [];
      
      const url = 'https://homerepairexperthk.com/addAppOrder2.php';
      axios.post(url, data).then((response) => {
        resultData = response.data;
        console.log("Response from web:", resultData);
        if (resultData === "Success" || resultData ==="Finished UpLoadSuccess") {
          sendNotification();
        }
        //setData(resultData[0]);
  
      
      }).catch((e) => console.log(e));
     
      /* 
       const url = 'https://homerepairexperthk.com/addAppOrder2.php';
       try {
         const response = axios.post(url, data, {
           headers: {
             Accept: 'application/json',
             'Content-Type': 'multipart/form-data'
           }
         });
 
         console.log('Response Data from addAppOrder:', response);
         console.warn(response.status);
         if (response.status === 200) {
           setIsLoading(false);
           console.log("Submit Success !");
         }
       } catch (error) {
         console.log(error);
         setIsLoading(false);
       }
       
     }
     */
    }
  }

  return (
    <div className="ServiceForm-Wrapper">
        <div className="ServiceForm-Content">
            <div className="ServiceForm-Body">
                <div className="ServiceForm-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;維修王申請表</div>  
                <div className="ServiceForm-Body-Context">
                    <div className="ServiceForm-Content">
                          <form onSubmit={pressHandler} className="form">
                                {/*** Name ****/}
                                <div className="highlight-content">
                                    <div className="input-box">
                                        <label className="label">聯絡人稱呼:</label>
                                        <input type="text"
                                            className="input"
                                            value={name}  
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                
                                {/*** Phone Num ****/}
                                <div className="highlight-content">
                                    <div className="input-box">
                                        <label className="label">電話:</label>
                                        <input type="text"
                                            className="input"
                                            value={phoneNum}  
                                            onChange={(e) => setPhoneNum(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                
                                {/***** Gender ******/}
                                <div className="highlight-content">
                                    <div className="input-box">
                                        <label className="label">性別:</label> 
                                        <div className="radio-group">
                                            <div className="radio-button">
                                              <input
                                                type="radio"
                                                id="male"
                                                value="male"
                                                checked={gender === 'male'}
                                                onChange={() => setGender('male')}
                                                className="radio-input"
                                              />
                                              <label htmlFor="male" className="radio-label">男</label>
                                            </div>
                                            <div className="radio-button">
                                              <input
                                                type="radio"
                                                id="female"
                                                value="female"
                                                checked={gender === 'female'}
                                                onChange={() => setGender('female')}
                                                className="radio-input"
                                              />
                                              <label htmlFor="female" className="radio-label">女</label>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                
                                {/************* District ****************/}
                                {!showDistrict ? (
                                  <div className="highlight-content">
                                    <label className="label">選擇地區: </label>
                                    {district === null ? (
                                      <div className="selected-container">
                                        {districtOptions.map((option) => (
                                          <button
                                            key={option.id}
                                            className={`selected-button ${district === option.id ? 'selected' : ''}`}
                                            onClick={() => handleDistrictSelect(option.id)}
                                          >
                                            {option.label}
                                          </button>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="selected-town-container">
                                        {townOptions.map((option) => (
                                          <button
                                            key={option.id}
                                            className={`selected-button ${town === option.id ? 'selected' : ''}`}
                                            onClick={() => handleTownSelect(option.id, option.label)}
                                          >
                                            {option.label}
                                          </button>
                                        ))}  
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="highlight-content">
                                    <div className="district-content">
                                      <span className="show-infor-header">地區: {townValue}</span>
                                      <button onClick={resetDistrict} className="district-button">
                                        重選
                                      </button>
                                    </div>  
                                  </div>
                                )}

                                {/********** Urgent ************/}
                                <div className="highlight-content">
                                  <div className="input-box">
                                    <label className="label">緊急:</label>
                                    <input
                                      type="checkbox"
                                      checked={urgent}
                                      onChange={() => setUrgent(!urgent)}
                                      className="switch"
                                    />
                                  </div>
                                </div>    
                                
                                {/******* Report Price **********/}
                                <div className="highlight-content">
                                  <div className="report-price-content">
                                    <span className="report-price-text">出價(約)</span>
                                    <input
                                      type="checkbox"
                                      checked={reportPriceState}
                                      onChange={() => setReportPriceState(!reportPriceState)}
                                      className="switch"
                                    />
                                  </div>    
                                  {reportPriceState && (
                                    <div className="report-price-content">
                                      <span>HK$</span>
                                      <input
                                        placeholder='出價'
                                        className="input"
                                        onChange={(e) => setReportPrice(e.target.value)}
                                        maxLength={10}
                                        type="number"
                                      />
                                    </div>  
                                  )}
                                </div> 

                                {/******* RfFamily ***********/}    
                                <div className="highlight-content">
                                  <div className="input-box">
                                    <label className="label">關愛家庭:</label>
                                    <input
                                      type="checkbox"
                                      checked={rfFamily}
                                      onChange={() => setRfFamily(!rfFamily)}
                                      className="switch"
                                    />
                                  </div>
                                  <span className="rf-family-text">
                                    關愛家庭包括:殘疾人士,長者及低收入家庭提供低於市價的維修服務
                                  </span>
                                </div>  

                                {/******** Comment  *********/}  
                                <div className="highlight-content">
                                  <div className="input-box">
                                    <label className="label">補充資料:</label>
                                    <textarea 
                                      className="input multiline-text"
                                      value={comment} 
                                      onChange={(e) => setComment(e.target.value)}
                                      rows={4}
                                    />
                                  </div> 
                                </div>  
                                  
                                {/*********** Image  **********/}   
                                {/******* Image Upload *******/}
                                <div className="highlight-content">
                                  <div className="image-upload-section">
                                    <label className="label">上傳相片:</label>
                                    
                                    {/* Hidden file input */}
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      onChange={handleFileSelect}
                                      accept="image/*"
                                      style={{ display: 'none' }}
                                    />
                                    
                                    {!imagePreview ? (
                                      <div className="upload-area" onClick={handleUploadClick}>
                                        <div className="upload-placeholder">
                                          <img
                                            className="upload-icon"
                                            src={require('../Image/icons8-camera-100.png')}
                                            alt="upload"
                                          />
                                          <span className="upload-text">點擊選擇圖片</span>
                                          <span className="upload-hint">支持 JPG, PNG 格式，最大 5MB</span>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="image-preview-container">
                                        <div className="image-preview">
                                          <img src={imagePreview} alt="Preview" className="preview-image" />
                                          <button className="remove-image-btn" onClick={handleRemoveImage}>
                                            ×
                                          </button>
                                        </div>
                                        <button className="change-image-btn" onClick={handleUploadClick}>
                                          更換圖片
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                  

                                {/*********** Notice **********/}
                                <div className="highlight-content">
                                  <div className="card-notice">
                                  <div className="card-notice-header">
                                    <span className="notice-header-text">注意事項</span>
                                  </div>
                                  <span className="notice-text">**所有師傅均持有維修王證書,在柯打資料內可瀏覽師傅資料及評分.</span>
                                  <span className="notice-text">**柯打內容及收費請直接與師傅協商.包括是否要收取檢查費等...</span>
                                  <span className="notice-text">**留意聯絡你的師傅是否與配對師傅資料相符.</span>
                                  <span className="notice-text">**柯打有效期為三日,到期後,將會被取消...如有需要請自行重發..</span>
                                  </div>
                                </div>     
                
                                {/***** Submit Button */}
                                <div className="button-container">
                                  <button
                                    onClick={pressHandler}
                                    className="submit-button"
                                  >發佈
                                  </button>
                                </div>
                          </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
              
  )
}

export default ServiceForm
